export default __webpack_public_path__ + "static/media/scrollRight.7515d690.png";